<template>
	<k-dialog v-model="dialog_open" persistent max-width="800px">
		<k-card>
			<k-card-title><b>Edit Co-teacher Permissions</b></k-card-title>
			<k-card-text>
				<div style="font-size:1.2em">
					<b>{{ coteacher.last_name }}, {{ coteacher.first_name }} ({{ coteacher.email }})</b>
				</div>
				<k-checkbox :label="'Can view student results?'" v-model="can_view_results" :disabled="true"
					:value="true" hide-details></k-checkbox>
				<k-checkbox :label="'Can view and edit student results?'" v-model="can_edit_results"
					@change="update_can_edit_results" :disabled="true || can_edit_activity" hide-details></k-checkbox>
				<k-checkbox :label="'Can edit activity content?'" v-model="can_edit_activity"
					@change="update_can_edit_activity" :disabled="true" hide-details></k-checkbox>
				<div class="mt-4">
					<i>Note: In the future, you will be able to restrict co-teachers to being able to view student
						results only, or allow co-teachers to edit activity content.</i>
				</div>
			</k-card-text>
			<k-card-actions class="pl-4 pr-4 pb-4">
				<k-btn color="red" dark @click="delete_coteacher">
					<k-icon small class="mr-2">fas fa-trash</k-icon> Remove From Course
				</k-btn>
				<k-spacer></k-spacer>
				<k-btn color="secondary" @click="$emit('editor_cancel')" class="mr-1">
					<k-icon small class="mr-2">fas fa-times</k-icon> Cancel
				</k-btn>
				<k-btn color="primary" @click="save_edits">
					<k-icon small class="mr-2">fas fa-check</k-icon> Save
				</k-btn>
			</k-card-actions>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	components: {},
	props: {
		coteacher: { type: Object, required: true, default() { return {} } },
	},
	computed: {
		...mapState(['user_info']),
		...mapGetters([]),
	},
	data() {
		return {
			dialog_open: true,
			can_view_results: true,
			can_edit_results: false,
			can_edit_activity: false,
		};
	},
	methods: {
		save_edits() {
			const payload = {
				coteacher_id: this.coteacher.coteacher_id,
				course_code: this.coteacher.course_code,
				coteacher_email: this.coteacher.email,
				user_id: this.user_info.user_id,
				origin_teacher_user_id: this.user_info.user_id,
				permission_level: this.can_edit_activity ? 2 : (this.can_edit_results ? 1 : 0)
			}
			this.$store.dispatch('save_coteacher', payload).then(x => {
				this.$emit("editor_cancel")
			})
		},
		update_can_edit_results(e) {
			this.can_edit_results = e
		},
		update_can_edit_activity(e) {
			if (e) {
				this.can_edit_activity = this.can_edit_results = true
			} else {
				this.can_edit_activity = false
			}
		},
		delete_coteacher() {
			this.$confirm({
				title: 'Are you sure?',
				text: 'Are you sure you want to remove this co-teacher from this course?',
				acceptText: 'Remove Co-teacher',
				acceptColor: 'red',
				dialogMaxWidth: 600
			}).then(y => {
				this.$store.dispatch('delete_coteacher', this.coteacher).then(x => {
					this.$emit('editor_cancel')
				})
			}).catch(n => { console.log(n) }).finally(f => { });
		},
	},
	created() {
		this.can_view_results = this.coteacher.permission_level >= 0
		this.can_edit_results = this.coteacher.permission_level >= 1
		this.can_edit_activity = this.coteacher.permission_level >= 2
	},
	mounted() { },
}

</script>

<style lang="scss"></style>
